import { ProductRatingRequest } from './../../../../models/product-rating-request';
import { Validators, UntypedFormGroup, UntypedFormControl, UntypedFormBuilder } from '@angular/forms';
import { Sku } from '@pdp/common';
import { ProductQuantity } from '../../../../models/product-quantity';
import { ProductService } from '../../../../providers/services/product.service';
import { CartService } from '../../../../providers/services/cart.service';
import { OrderItemRequest } from '../../../../models/order-item-request';
import { takeUntil } from 'rxjs/operators';
import { AppComponent } from '../../../../app.component';
import { Subject } from 'rxjs';
import { Media } from '../../../../models/media';
import { SelectDropdown0Validator } from '../../../../common/validator/select-dropdown-0-validator';
import { EntityToMedia } from '../../../../models/entity-to-media';
import { Directive } from '@angular/core';
import { PlatformToastMessage, PlatformToastMessageType, Product } from '@pdp/common';
import { ProductRatingService } from '@shop/app/providers/services/product-rating.service';
import { NavigationExtras, Router, ActivatedRoute } from '@angular/router';

@Directive()
export class AbstractProductDetails {

    protected unsubscribe: Subject<void> = new Subject();

    public product: Product;
    public dummyElem = document.createElement('DIV');

    public routerLinkUrl: string;

    public formGroup: UntypedFormGroup;
    public loading = false;
    public currentSku: Sku;
    public defaultSkuDescription: string;
    public defaultSkuLongDescription: string;
    public productQuantity: ProductQuantity;
    public productOptionsAsmap = {};
    public allAllowedOptionValues: Media[] = [];
    public hasSizeOption: boolean;
    // za prikaz ikonica u select dropdown
    public selectedOptionIcons: any[] = [];
    public currentImage: Media;
    public additionalImageMedias: Media[];

    constructor(public carService: CartService,
        public productService: ProductService,
        public router: Router,
        public activatedRoute: ActivatedRoute,
        public formBuilder: UntypedFormBuilder,
        public ratingService: ProductRatingService) {
        this.buildForm();
    }

    public buildForm(): void {
        this.formGroup = this.formBuilder.group({
            quantity: ['1', [
                Validators.required,
                Validators.pattern('^[0-9]+$')
            ]],
            options: this.formBuilder.group([])
            /*formArray : new FormArray([])*/
        });
    }

    public updateRating(rating: number) {
        const request: ProductRatingRequest = new ProductRatingRequest();
        request.productId = this.product.id;
        request.rating = rating;
        this.ratingService.rateProduct(request).pipe(takeUntil(this.unsubscribe)).subscribe(() => {

        });
    }
    public addToCart() {
        if (!(this.product.skuCount > 1)) {
            // i had to assign this.routerLinkUrl to local variable link, otherwise i get Unhandled Navigation Error from angular router w/e
            const link = this.routerLinkUrl;
            const navigationExtras: NavigationExtras = {
                relativeTo: this.activatedRoute,
                queryParams: {
                    'itm': this.product.id
                }
            };
            this.router.navigate([link], navigationExtras)
            // this.router.navigate(['/search/itm' + this.product['product_url']], { queryParams: { itm: this.product.id } })
            return;
        }
        const model = this.formGroup.value;
        if (this.formGroup.valid) {
            this.loading = true;

            model['itemAttributes'] = {};
            const productOptions = this.product['productOptions'];
            for (const key in model['options']) {
                let attributePosition: any;
                for (let i = 0; i < productOptions.length; i++) {
                    // this.productOptions is an array with indexes 0,1,2,3 we need to find right index for our key based on attribudeName
                    if (productOptions[i]['name'] === key) {
                        attributePosition = i;
                        break;
                    }
                }
                model['itemAttributes'][productOptions[attributePosition]['name']] = model['options'][key];
            }
            const orderItemRequest: OrderItemRequest = this.prepareOrderItemRequest(model);
            this.carService.addProduct(orderItemRequest)
                .pipe(takeUntil(this.unsubscribe))
                .subscribe(res => {
                    AppComponent.toastSubject.next(new PlatformToastMessage(PlatformToastMessageType.SUCCESS, $localize`:@@UspesnoDodatoUKorpu:Uspešno dodato u korpu`));
                    this.loading = false;
                },
                    () => {
                        this.loading = false;
                        AppComponent.toastSubject.next(new PlatformToastMessage(PlatformToastMessageType.ERROR, 'Došlo je do greške. Proizvod ' +
                            this.product['name'] + ' (' + orderItemRequest.quantity + 'kom) nije dodat u korpu!'));

                    });
        }
    }

    protected prepareProductInfo() {
        this.routerLinkUrl = '/search/itm' + this.product.url;
        this.currentSku = this.product.defaultSku;
        if (this.product && this.product.defaultSku && this.product.defaultSku.description) {

        }
        this.defaultSkuDescription = this.decode(this.product.defaultSku.description, 250);
        this.defaultSkuLongDescription = this.product.defaultSku.longDescription;

        this.productQuantity = this.productService.computeQuantity(this.currentSku['quantityAvailable'], this.currentSku['salesAvailabilityType']);

        for (const currentProductOption of this.product['productOptions']) {
            this.productOptionsAsmap[currentProductOption['name']] = currentProductOption;
            for (const currentAllowedValue of currentProductOption['selectedValues']) {
                // For same product options for example : Siva we can have for color and also for boja konstrukcije.
                // We will need this in findMatchingSku
                currentAllowedValue['optionName'] = currentProductOption['name'];
                this.allAllowedOptionValues.push(currentAllowedValue);
                if (currentAllowedValue && currentAllowedValue.optionName === 'Size') {
                    this.hasSizeOption = true;
                }
            }
        }
        const formControls: UntypedFormControl[] = this.prepareDynamicFormFields(this.product['productOptions']);
        formControls.sort((a, b) => a['displayOrder'] - b['displayOrder']);
        formControls.forEach(formControl => {
            const optionsGroup = <UntypedFormGroup>this.formGroup.controls['options'];
            optionsGroup.addControl(formControl['name'], formControl);
        });
        const currentSkuMediaMap = this.currentSku['mediaMap']; // use dafault sku for initial displaying of images

        this.displayMedia(currentSkuMediaMap);
        this.formGroup.valueChanges
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(data => this.onValueChanged(data));
    }


    private displayMedia(mediaMap: any) {
        if (mediaMap && (mediaMap['PRIMARY'] || mediaMap['ADDITIONAL'])) {
            const primaryImages = mediaMap['PRIMARY'];
            if (primaryImages) {
                let cur = primaryImages[0]['media'];
                cur.url = cur.url;
                this.currentImage = cur;
            }
            // additional images
            const additionalImages: EntityToMedia[] = mediaMap['ADDITIONAL'];
            if (additionalImages) {
                this.additionalImageMedias = [];
                const unfilteredAdditionalImages: Media[] = [];
                for (const additionalImage of additionalImages) {
                    unfilteredAdditionalImages.push(additionalImage.media);
                }
                unfilteredAdditionalImages.push(this.currentImage);
                this.additionalImageMedias = this.additionalImageMedias.concat(unfilteredAdditionalImages);
            }

        } else {
            this.currentImage = Media.createMediaNotFound();
        }
    }


    private prepareOrderItemRequest(model: any): OrderItemRequest {
        const orderItemRequest: OrderItemRequest = new OrderItemRequest(this.product.id,
            null, //obrisati ovaj property. Ko zna sta je to
            model['quantity'],
            model['itemAttributes']);

        orderItemRequest.skuId = this.currentSku.skuId;
        // We do not use this in the backend
        // orderItemRequest.skuOptionIds = this.currentSku['productOptionValueIds'];

        return orderItemRequest;
    }

    /**
     * Build dynamic form fields
     */
    private prepareDynamicFormFields(productOptions: any): UntypedFormControl[] {
        const formControls: UntypedFormControl[] = [];

        productOptions.forEach(option => {
            const controlName = option['name'];
            const controlDisplayOrder = option['displayOrder'];
            const formControl = option.required ? new UntypedFormControl(0, [Validators.required, SelectDropdown0Validator.selectDropdownCheck]) :
                new UntypedFormControl(0, []);

            Object.defineProperty(formControl, 'name', { value: controlName });
            Object.defineProperty(formControl, 'displayOrder', { value: controlDisplayOrder });


            formControls.push(formControl);

            if (option.required) {
                this.formErrors[controlName] = '';
                this.validationMessages[controlName] = {
                    'required': 'Opcija je obavezna',
                };
            }
        });
        return formControls;
    }

    /**
    *
    * Initially we set default sku to be currentSku that means default sku information will be displayed when screen loads
    * including price,description etc
    * On each option change we need to iterate over all options and find matching sku by selected option so
    * that we can update price image etc..
    */
    private findMatchingSku(options: any[]) {
        const selectedOptionValueIds = [];
        for (const currentSelectedOptionName of Object.keys(options)) {
            for (const currentAllWdValue of this.allAllowedOptionValues) {
                const currentAllWdValueName = currentAllWdValue['productOptionValue']['attributeValue'];
                const currentAllWdValueOptionName = currentAllWdValue['optionName'];
                // Match Bela but we can have Bela in Multiple options like Color and Bojan konstrukcije.
                // So we need to match the option name as well
                if (currentAllWdValueOptionName === currentSelectedOptionName &&
                    options[currentSelectedOptionName] === currentAllWdValueName) {
                    const matchedAllwdValueId = currentAllWdValue['productOptionValue']['id'];
                    selectedOptionValueIds.push(matchedAllwdValueId);

                    // ispod su ikonice za odabrane opcije
                    this.selectedOptionIcons = this.selectedOptionIcons
                        .filter(e => e.optionId !== currentAllWdValue['productOptionValue']['productOptionId']);
                    this.selectedOptionIcons.push({
                        optionId: currentAllWdValue['productOptionValue']['productOptionId'],
                        optionValueId: matchedAllwdValueId,
                        productOptionName: currentAllWdValue['productOptionValue']['productOptionName'],
                        productOptionValueName: currentAllWdValue['productOptionValue']['attributeValue'],
                        displayOrder: currentAllWdValue['productOptionValue']['displayOrder'],
                        media: currentAllWdValue['productOptionValue']['media']
                    });

                }
            }
        }

        let matched = false;
        for (const currentSku of this.product.allskus) {
            matched = this.findMatchingSkuByOption(currentSku, selectedOptionValueIds);
            if (matched) {
                this.currentSku = currentSku;
                break;
            }
        }
        if (!matched) {
            // because we may have many options and customer may select unavailable combination we will revert to default sku
            // FIXME we shouldnt prevent combinations that do not exist
            this.currentSku = this.product['defaultSku'];
        }
    }

    /**
     *
     * @param sku Returns true only if all options this sku has are selected
     * @param selectedOptionValueIds - list of selected options
     */
    private findMatchingSkuByOption(sku: any, selectedOptionValueIds: number[]): boolean {
        // if there are product options check if all selected options are in sku
        // if there are none product options sku is default sku and we should return true
        if (sku && sku['productOptionValueIds'] && sku['productOptionValueIds'].length > 0) {

            for (const currentProductOptionValueId of selectedOptionValueIds) {
                if (sku['productOptionValueIds'].indexOf(currentProductOptionValueId) < 0) {
                    return false;
                }
            }
        }
        return true;
    }

    // https://stackoverflow.com/questions/43712502/convert-ltpgt-to-p-and-use-to-format-html
    // &lt;p&gt;Detalji o proizvodu:&lt;/p&gt;&lt;p&gt;&lt;br&gt;&lt;/p&gt;&lt;p&gt;Tip: bušač &lt;/p&gt;&lt;p&gt;
    // ovaj tip opisa ne radi dobro sa InnerHtml tako da primenjujem ovaj hack
    public decode(text: string, maxLength?: number): string {
        if (!text) {
            return '';
        }
        if (text.indexOf('<') >= 0) {
            // pravilno snimljen description u formatu
            // <hr />\r\n<p class=\"western\"><font><font><font><font>Канцеларијски сто из линије
            //  Буџет нуди најбољи одност цене и квалитета.
            // </font></font></font><font><font><font>Можете га користити као слободностојећи сто
            // je prikazan lepo kada se samo nalepi u [innerHtml]
            return text;
        }

        // dok encodiran description u formatu
        // &lt;p&gt;Detalji o proizvodu:&lt;/p&gt;&lt;p&gt;&lt;br&gt;&lt;/p&gt;&lt;p&gt;Tip: bušač &lt;/p&gt;&lt;p&gt;
        // nije prikazan lepo pa ga zato dva puta dekodiramo jednom u ovoj metodi i da se dobije format
        // <p>Detalji o proizvodu:</p><p><br></p><p>Tip: bušač </p><p>Kapacitet: 12 listova
        // </p><p>Boja: crvena</p><p>Proizvođač: A PLUS<br></p>
        // i zatim ovako dekodiran string se nalepi u [innerHtml] i sve radi lepo
        let ret = '';

        this.dummyElem.innerHTML = text;
        document.body.appendChild(this.dummyElem);
        ret = this.dummyElem.textContent; // just grab the decoded string which contains the desired HTML tags
        document.body.removeChild(this.dummyElem);
        if (maxLength && ret.length > maxLength) {
            ret = ret.substring(0, maxLength) + '...';
        }
        return ret;
    }

    /**
     * Performs validation of form after each input field value changes
     */
    private onValueChanged(data?: any) {
        if (!this.formGroup) {
            return;
        }
        this.findMatchingSku(data['options']);
        // this.findSelectedOptionIcon(data['options']);
        const form = this.formGroup;

        for (const field in this.formErrors) {
            // clear previous error message (if any)
            this.formErrors[field] = '';
            let control = form.get(field);
            if (!control) {
                control = form.get('options').get(field);
            }
            if (control) {
                const value = Number(control.value);
                if (value === 0) {
                    control.setErrors({ 'required': false });
                }
            }

            if (control && /*control.dirty &&*/ !control.valid) {
                const messages = this.validationMessages[field];
                for (const key in control.errors) {
                    this.formErrors[field] += messages[key] + ' ';
                }
            }
        }
    }

    private formErrors = {
        'quantity': '',
    };

    public validationMessages = {
        'quantity': {
            'required': 'Količina je obavezna',
            'pattern': 'Količina može da sadrži samo brojeve'
        }
    };

    ngOnDestroy() {
        this.unsubscribe.next(undefined);
        this.unsubscribe.complete();
    }

}